import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { blogsData } from "../Blog";

const HomeBlogs = ({
  excludeSlug = "",
}) => {

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // CARD ANIMATION
  const cardVariant = {
    hidden: {
      opacity: 0,
      y: 55,
      scale: 0.97,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        delay: i * 0.1,
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };
const filteredBlogs = excludeSlug
  ? blogsData.filter(
      (blog) => blog.slug !== excludeSlug
    )
  : blogsData;

const latestBlogs =
  filteredBlogs.slice(0, 3);

  return (
    <>
      <section className="home-blogs-section container">

        {/* TOP */}

        <motion.div
          className="services-top"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.15,
              },
            },
          }}
        >

          <motion.h2
            className="section-heading center-heading"
            variants={fadeUp}
          >
            Latest Insights &
            <span> Property Guides</span>
          </motion.h2>

          <motion.div
            className="heading-line"
            initial={{
              width: 0,
              opacity: 0,
            }}
            whileInView={{
              width: "120px",
              opacity: 1,
            }}
            transition={{
              duration: 1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
            }}
          />

          <motion.p
            className="section-text center-text"
            variants={fadeUp}
          >
            Stay informed with expert advice, market updates,
            and practical step-by-step guides designed to help
            you navigate your WA property journey with complete confidence.
          </motion.p>

        </motion.div>

        {/* GRID */}

        <motion.div
          className="blogs-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.12,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.12,
              },
            },
          }}
        >

          {latestBlogs.map((item, i) => (

            <motion.div
              className="blog-card"
              key={i}
              custom={i}
              variants={cardVariant}
              whileHover={{
                y: -6,
              }}
              transition={{
                duration: 0.3,
              }}
            >

              {/* IMAGE */}

              <div className="blog-img-wrap">

                <motion.img
                  src={item.image}
                  alt={`${item.title} | LDL Settlement Services`}
                  whileHover={{
                    scale: 1.06,
                  }}
                  transition={{
                    duration: 0.55,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                />

              </div>

              {/* CONTENT */}

              <div className="blog-content">

                <h3 className="card-heading">
                  {item.title}
                </h3>

                <p className="section-text">
                  {item.desc}
                </p>

                <Link className="blog-read-btn" to={`/blog/${item.slug}`}>
                  Read More
                  <span>❯</span>
                </Link>

              </div>

            </motion.div>

          ))}

        </motion.div>

      </section>
    </>
  );
};

export default HomeBlogs;